<oauth>
  <script>
      import di        from 'dependeny-injection'
      import Validator from '@croco/validator'

      export default {
          onMounted(){
            scrollTo(0, 0);
            di.register.api('/oauth',{})
            .then(function(data){
                if(!data.status) {
                  alert(data.message);
                  alert("メールアドレスによる登録に遷移します")
                  di.route.router.push("");
                  return;
                }
                di.register.secondCode = data.secondCode;
                di.register.masked_mail = data.data.masked_mail;
                di.register.coreData["familyName"] = data.data.familyName;
                di.register.coreData["firstName"] = data.data.firstName;
                di.route.router.push("/input-information");
            })
          }
      }
  </script>
</oauth>
